export default "__VITE_ASSET__DGcOWnbb__"